import { motion } from "framer-motion";
import { Eye, Shield, MapPin, Wallet } from "lucide-react";

const points = [
  { icon: Eye, title: "Näet mallisivut ennen ostopäätöstä", text: "Rakennamme mallisivut yrityksellesi ilmaiseksi ennen kuin sitoudut mihinkään." },
  { icon: Shield, title: "Selkeät sopimusehdot", text: "12 kk sitoutuminen, jonka jälkeen irtisanominen kuukauden irtisanomisajalla – ei piilotettuja lisämaksuja." },
  { icon: MapPin, title: "Paikallinen ja tavoitettava", text: "Palvelemme henkilökohtaisesti asiakkaita koko Suomessa." },
  { icon: Wallet, title: "Kiinteä hinta – ei yllätyksiä", text: "Selkeät paketit, kiinteä kuukausihinta. Tiedät aina mistä maksat." },
];

export default function WhyUs() {
  return (
    <section className="md-section" id="miksi" data-testid="why-us-section">
      <div className="md-container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-12 md:mb-16"
        >
          <span className="md-eyebrow">Miksi MyyntiDrive</span>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Neljä syytä valita <span className="text-[#00E5FF]">meidät.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {points.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="md-card p-8 flex gap-5 hover:border-[#0066FF]/40 transition-colors"
              data-testid={`why-us-${i + 1}`}
            >
              <div className="h-12 w-12 shrink-0 rounded-2xl bg-[#0066FF]/15 border border-[#0066FF]/30 grid place-items-center text-[#00E5FF]">
                <p.icon size={22} strokeWidth={1.75} />
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold text-white">{p.title}</h3>
                <p className="mt-2 text-white/60 leading-relaxed">{p.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
